const uri = 'https://gateway.magnaflow.com:8383/api/v1/webhook';

function addItem() {
    const addYearTextbox = document.getElementById('Year');
    const addMakeTextbox = document.getElementById('Make');
    const addModelTextbox = document.getElementById('Model');
    const addSubmodelTextbox = document.getElementById('Submodel');
    const addEngineLiterTextbox = document.getElementById('EngineLiter');
   
    const addModsTextbox = document.getElementById('Mods');
    const addModsDescriptionTextbox = document.getElementById('ModsDescription');
    const addNameTextbox = document.getElementById('Name');
    const addEmailTextbox = document.getElementById('Email');
    const addPhoneTextbox = document.getElementById('Phone');
    const addStateTextbox = document.getElementById('State');

    let isMod

    if (addModsTextbox.value.trim() == 'true')
        isMod = true
    else
        isMod = false

        const item = {
            sender: 'VehicleRequestForm',
            action: 'add',
            data:{
            year: parseInt(addYearTextbox.value.trim()),
            make: addMakeTextbox.value.trim(),
            model: addModelTextbox.value.trim(),
            submodel: addSubmodelTextbox.value.trim(),
            engineLiter: addEngineLiterTextbox.value.trim(),
            isModified: isMod,
            modsDescription: addModsDescriptionTextbox.value.trim(),
            name: addNameTextbox.value.trim(),
            email: addEmailTextbox.value.trim(),
            phoneNumber: addPhoneTextbox.value.trim(),
            state: addStateTextbox.value.trim(),
            }
        };

    fetch(uri, {
        method: 'post',
        headers: {
            'Authorization': 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJNYWduYUZsb3ciLCJpYXQiOjE2MzE1NTU2ODMsImV4cCI6MTc1Nzc4NjA4MywiYXVkIjoiRXh0ZXJuYWwiLCJzdWIiOiIifQ.2usbA_3TWER1W7C6hfFA7AkyEiE0JJh45HKYXBzB2eM',
        	'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*'
        },
        body: JSON.stringify(item)
    }).then(function(response) {
        if (response.ok === true) {
            window.location.href = '../pages/new-vehicle-request-confirmation';
        } else {
            alert('Form not submitted, please try again.');
        }
    });
}